import { graphql, useStaticQuery } from 'gatsby';
import React, { FC, useContext } from 'react';

import FlexColumn from '@ui/atoms/FlexColumn';
import LoadingWrapper from '@ui/atoms/LoadingWrapper';
import Skeleton from '@ui/atoms/Skeleton';

import CenteredGridItem from '@ui/molecules/CenteredGridItem';

import EmergencyContactsEditStep, {
	IEmergencyContactsPageContent,
} from '@ui/routes/shared/EmergencyContactsEditStep/EmergencyContactsEditStep.component';

import useMemberInfo from '@hooks/useMemberInfo';

import { keysToCamel } from '@utils/butter';
import { exists } from '@utils/general';

import FlowContext from '@providers/FlowContextProvider';

import { IFlowStepProps } from '@folx-types/flow-steps';
import { IContact } from '@folx-types/member';

import { emergencyContacts, emergencyContactsName } from '@graphql/fragments/emergencyContact';

interface IEmergencyContactsEditStepPageProps extends IFlowStepProps {}

const EmergencyContactsEditStepPage: FC<IEmergencyContactsEditStepPageProps> = ({
	path,
	stepKey,
	...props
}) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "emergency-contact" }) {
				page_header
				page_info
			}
		}
	`);

	const { handleNavBack, handleNavNext } = useContext(FlowContext);
	const handleNavigate = () => handleNavNext(stepKey);

	const { memberInfo, loading } = useMemberInfo<{ emergencyContacts: IContact[] }>([
		{ name: emergencyContactsName, node: emergencyContacts },
	]);

	const reverse = props?.location?.state?.reverse ?? {};

	if (!loading && exists(memberInfo?.emergencyContacts)) {
		exists(reverse) && !!reverse ? handleNavBack(stepKey) : handleNavNext(stepKey);
	}

	const refinedContent: IEmergencyContactsPageContent = keysToCamel(
		pageContent
	) as IEmergencyContactsPageContent;

	return (
		<LoadingWrapper
			skeleton={
				<CenteredGridItem>
					<FlexColumn gap="sm">
						<Skeleton fullWidth height="lg" />
						<Skeleton fullWidth structure="column" gap="xs" repeated={3} height="sm" />
					</FlexColumn>
				</CenteredGridItem>
			}
			loading={loading || exists(memberInfo?.emergencyContacts)}>
			<CenteredGridItem>
				<EmergencyContactsEditStep
					path={path}
					member={memberInfo}
					handleNavigate={handleNavigate}
					pageContent={refinedContent}
				/>
			</CenteredGridItem>
		</LoadingWrapper>
	);
};

export default EmergencyContactsEditStepPage;
